import React, {useState, useEffect} from 'react'
import { changePassword } from '../../../../store/actions/profile';

//Hooks
import {useDispatch, useSelector} from 'react-redux';
import { useTranslation } from 'react-i18next';

//Components
import TextInput from '../../../../components/ui/TextInput/TextInput';
import SubmitButton from '../../../../components/ui/SubmitButton/SubmitButton';
import ScreenFooter from '../../../../components/ScreenFooter/ScreenFooter';

//Styles
import Styles from './EditPassword.module.scss';

const EditPassword = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [retypePassword, setRetypePassword] = useState('');
    const [validationErrors, setValidationErrors] = useState({});
    
    const dispatch = useDispatch()
    const changePasswordValidationErrors = useSelector(state => state.profile.changePasswordValidationErrors);
    const isLoading = useSelector(state => state.ui.isLoading);
    const [disabled, setDisabled] = useState(true)
    const {t} = useTranslation('common')

    useEffect(() => {
        setValidationErrors(changePasswordValidationErrors);
    }, [changePasswordValidationErrors]);

    useEffect(() => {
        if(currentPassword !== '' && newPassword !== '' && retypePassword !== '') {
            setDisabled(false)
        } else {
            setDisabled(true)
        }
    },  [newPassword, currentPassword, retypePassword]);

    const changePasswordHandler = () => {
        if(newPassword !== retypePassword) {
            setValidationErrors({...validationErrors, retypePassword: t('myProfile.editPassword.passwordsDoNotMatch')}); 
            return
        }
        dispatch(changePassword(currentPassword, newPassword))
    }

    return (
        <>
            <div className={Styles.container}>
                <TextInput
                    data-testid='input1'
                    value={currentPassword}
                    validationError={validationErrors.currentPassword}
                    setInputValue={(value) => {
                        setCurrentPassword(value);  
                        setValidationErrors({...validationErrors, currentPassword: null})
                    }}
                    name={t('myProfile.editPassword.currentPassword')}
                    type='password'
                />
                <TextInput
                    data-testid='input2'
                    value={newPassword}
                    validationError={validationErrors.newPassword}
                    setInputValue={(value) => {
                        setNewPassword(value);  
                        setValidationErrors({...validationErrors, newPassword: null})
                    }}
                    name={t('myProfile.editPassword.newPassword')}
                    type='password'
                />
                <TextInput
                    data-testid='input3'
                    value={retypePassword}
                    validationError={validationErrors.retypePassword}
                    setInputValue={(value) => {
                        setRetypePassword(value);  
                        setValidationErrors({...validationErrors, retypePassword: null})
                    }}
                    name={t('myProfile.editPassword.retypeNewPassword')}
                    type='password'
                />
            </div>
            <ScreenFooter visible={true}>
                <SubmitButton
                    data-testid='button1'
                    submitHandler={changePasswordHandler}
                    isLoading={isLoading}
                    disabled={disabled}
                >
                    {t('myProfile.editPassword.changePassword').toUpperCase()}
                </SubmitButton>
            </ScreenFooter>
        </>
    )
}


export default EditPassword